import './PeriscopePaginatedList.scss';
import { OffsetPaginatedResource } from '@sonar-software/sonar-ts-types';
import { UpdateQueryParams } from '@hooks';
import { PaginationQueryParams, PeriscopeList, PeriscopePagination } from '.';
import React, { useRef } from 'react';

export interface PeriscopePaginatedListProps {
	list: (items: unknown[]) => React.ReactNode;
	loading: boolean;
	onChange: UpdateQueryParams<PaginationQueryParams>;
	queryParams: PaginationQueryParams;
	resource?: OffsetPaginatedResource<unknown>;
	title?: string;
}

export const PeriscopePaginatedList: React.FC<PeriscopePaginatedListProps> = ({
	list,
	loading,
	onChange,
	queryParams,
	resource,
	title
}) => {
	const scrollableListRef = useRef<HTMLDivElement>(null);
	const totalCount = resource?.totalCount ?? 0;
	const results = resource?.results ?? [];

	return (
		<>
			{ title && <div className='periscope-list-title'>{ title }</div> }
			<PeriscopeList
				list={ list }
				loading={ loading }
				ref={ scrollableListRef }
				results={ results } />
			<PeriscopePagination
				loading={ loading }
				onChange={ onChange }
				queryParams={ queryParams }
				scrollRef={ scrollableListRef }
				totalCount={ totalCount } />
		</>
	);
};
